
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { routeNames } from "@/router";
import store from "@/stores";

export default defineComponent({
  name: "AdminMenu",
  components: {},
  props: {},
  setup() {
    const router = useRouter();
    const login = store.useLoginStore();
    // 契約管理画面へ遷移
    const toContract = () =>
      router.push({
        name: routeNames.AdminContract,
      });
    // メンテナンス情報登録画面へ遷移
    const toMaintenance = () =>
      router.push({
        name: routeNames.AdminMaintenance,
      });
    // 管理者情報画面へ遷移
    const toUsers = () =>
      router.push({
        name: routeNames.AdminUsers,
      });
    // ログアウト
    const logout = async () => {
      if (await login.signout()) {
        await router.push({ name: routeNames.AdminLogin });
      }
    };
    return {
      toContract,
      toMaintenance,
      toUsers,
      logout,
    };
  },
});
